import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [{
		path: '/',
		name: 'index',
		component: () => import('../views/index.vue')
	},
	{	// 登录
		path: '/login',
		name: '/login',
		component: () => import('../views/login.vue')
	},
	{	// 代理商
		path: '/agent',
		name: '/agent',
		component: () => import('../views/navMenu/agent.vue')
	},
	{	// 优惠券
		path: '/coupon',
		name: 'coupon',
		component: () => import('../views/navMenu/coupon.vue')
	},
	{	// 学员
		path: '/cadet',
		name: 'cadet',
		component: () => import('../views/navMenu/cadet.vue')
	},
	{	// 订单
		path: '/order',
		name: 'order',
		component: () => import('../views/navMenu/order.vue')
	},
	{	// 讲师
		path: '/lecturer',
		name: 'lecturer',
		component: () => import('../views/navMenu/lecturer.vue')
	},
	{	// 代课程
		path: '/course',
		name: 'course',
		component: () => import('../views/navMenu/course.vue')
	},
	{	// 讲师-简历
		path: '/add_teacher',
		name: 'add_teacher',
		component: () => import('../views/navMenu/lecturer/add_teacher.vue')
	},
	{	// 活动
		path: '/active',
		name: 'active',
		component: () => import('../views/navMenu/active.vue')
	},
	{	// 等级
		path: '/grade',
		name: 'grade',
		component: () => import('../views/navMenu/grade.vue')
	},
	{	// 系统变量
		path: '/sys',
		name: 'sys',
		component: () => import('../views/navMenu/sys.vue')
	},
	{	// 课程新增
		path: '/course_add',
		name: 'course_add',
		component: () => import('../views/navMenu/course/course_add.vue')
	},
	{	// 课程-班次列表
		path: '/Sheet_list',
		name: 'Sheet_list',
		component: () => import('../views/navMenu/course/Sheet_list.vue')
	},
	{	// 课程-班次添加/编辑
		path: '/Sheet_add',
		name: 'Sheet_add',
		component: () => import('../views/navMenu/course/Sheet_add.vue')
	},
	{	// 课程-班次-课程列表
		path: '/kcb_list',
		name: 'kcb_list',
		component: () => import('../views/navMenu/course/kcb_list')
	},
	{	// 课程-已报名班次列表
		path: '/yibaom_list',
		name: 'yibaom_list',
		component: () => import('../views/navMenu/course/yibaom_list')
	},
	{	// 课程-已报名班次列表
		path: '/city',
		name: 'city',
		component: () => import('../views/navMenu/agent/city')
	}
]

const router = new VueRouter({
	routes
})

// 路由导航守卫
// router.beforeEach((to, from, next) => {
// 	if (to.path === '/login') return next() // 类似白名单，如果进入的事login页面直接放行
// 	const tokenStr = window.sessionStorage.getItem('user_info')
// 	if (!tokenStr) return next('/login') // 如果没有token强制跳转至login页面
// 	next() // 如果token存在直接放行
// })

export default router